import { z } from 'zod/v4';

import { popupFlowDataSchema } from './actions';
import type { InfinexMessageNamespace } from './base';
import { generateEventSchema } from './schemaBuilder';

export const PopupInfoMethods = ['open-popup'] as const;
export type PopupInfoMethod = (typeof PopupInfoMethods)[number];

const namespace: InfinexMessageNamespace = 'popup-info';

export const openPopupRequestSchema = generateEventSchema({
  namespace,
  method: 'open-popup',

  requestData: popupFlowDataSchema,
  responseData: z.boolean(),
  notificationData: z.null(),
});

export const requestClosePopupSchema = generateEventSchema({
  namespace,
  method: 'close-popup',

  requestData: z
    .object({
      popupId: z.string(),
    })
    .catchall(z.any()),
  responseData: z.boolean(),
  notificationData: z.never(),
});

export const updatePopupRequestSchema = generateEventSchema({
  namespace,
  method: 'update-popup-request',

  requestData: z.any(),
  responseData: z.boolean(),
  notificationData: z.null(),
});

export const popupClosedNotificationSchema = generateEventSchema({
  namespace,
  method: 'popup-closed',

  requestData: z.never(),
  responseData: z.never(),
  notificationData: z
    .object({
      popupId: z.string(),
    })
    .catchall(z.any()),
});

export const popupRequestProcessedSchema = generateEventSchema({
  namespace,
  method: 'popup-request-processed',

  requestData: z.never(),
  responseData: z.never(),
  notificationData: z
    .object({
      popupId: z.string(),
    })
    .catchall(z.any()),
});

export const popupResponseSchema = generateEventSchema({
  namespace,
  method: 'popup-data',

  requestData: z.never(),
  responseData: z.never(),
  notificationData: z
    .object({
      popupId: z.string(),
      response: z.any(),
    })
    .catchall(z.any()),
});

/* ─────────────────── Aggregated schema arrays ─────────────────── */
export const popupInfoRequestParamSchemas = [
  openPopupRequestSchema.requestParamsSchema,
  updatePopupRequestSchema.requestParamsSchema,
  requestClosePopupSchema.requestParamsSchema,
] as const;

export const popupInfoResponseParamSchemas = [
  openPopupRequestSchema.responseParamsSchema,
  updatePopupRequestSchema.responseParamsSchema,
  requestClosePopupSchema.responseParamsSchema,
] as const;

export const popupInfoNotificationParamSchemas = [
  popupResponseSchema.notificationParamsSchema,
  popupClosedNotificationSchema.notificationParamsSchema,
  popupRequestProcessedSchema.notificationParamsSchema,
] as const;

export const popupInfoRequestEventSchemas = [
  openPopupRequestSchema.requestSchema,
  updatePopupRequestSchema.requestSchema,
  requestClosePopupSchema.requestSchema,
] as const;

export const popupInfoResponseEventSchemas = [
  openPopupRequestSchema.responseSchema,
  updatePopupRequestSchema.responseSchema,
  requestClosePopupSchema.responseSchema,
] as const;

export const popupInfoNotificationEventSchemas = [
  popupResponseSchema.notificationSchema,
  popupClosedNotificationSchema.notificationSchema,
  popupRequestProcessedSchema.notificationSchema,
] as const;
